// Vote Analysis API helpers
const resolveDefaultLlmUrl = () => {
  if (typeof window !== 'undefined' && window.location) {
    const { protocol, host } = window.location;
    return `${protocol}//${host}/api/llm`;
  }
  try {
    if (typeof location !== 'undefined') {
      return `${location.protocol}//${location.host}/api/llm`;
    }
  } catch (_) {}
  return 'http://localhost:5001';
};

const LLM_URL = process.env.REACT_APP_LLM_URL || resolveDefaultLlmUrl();

async function authHeaders() {
  try {
    const { getToken } = await import('../firebase.js');
    const token = await getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getVoteAnalysis() {
  const headers = await authHeaders();
  const res = await fetch(`${LLM_URL}/v1/voteAnalysis`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || `HTTP ${res.status}`);
  }
  return res.json();
}
